const ENHANCEMENT_REPORTER_HEADING = "Suggest a Monuvision enhancement"

const ENHANCEMENT_REPORTER_APPEARANCE = Object.freeze({
  themeMode: "auto",
  className: "monuvision-enhancement-reporter-dialog",
  tokens: Object.freeze({
    accent: "#224f6e",
    accentText: "#ffffff",
    radius: "4px",
    fontFamily: "'Open Sans', sans-serif",
  }),
})

function enhancementReporterAppearance(css = globalThis.CSS) {
  // Older browsers accept custom properties but cannot resolve light-dark()
  // inside them, leaving the SDK's surfaces transparent. Use its light preset.
  if (css && typeof css.supports === "function" && css.supports("color", "light-dark(white, black)")) {
    return ENHANCEMENT_REPORTER_APPEARANCE
  }

  return { ...ENHANCEMENT_REPORTER_APPEARANCE, themeMode: "light" }
}

module.exports = {
  ENHANCEMENT_REPORTER_APPEARANCE,
  ENHANCEMENT_REPORTER_HEADING,
  enhancementReporterAppearance,
}
